import React from 'react'

const Footer = () => {
  return (
    <footer>
      <p>
        <a href='https://www.linkedin.com/in/carolina-vargas-orozco/' target='_blank'><i className="fa-brands fa-linkedin"></i></a>
        <a href='https://github.com/vargacar' target='_blank'><i className="fa-brands fa-github"></i></a>
        
      </p>
      <p>All Rights Reserved 2023</p>
    </footer>
  )
}

export default Footer